module.exports = __webpack_public_path__ + "static/img/alliance-retail-group_logo.5784aca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/alliance-retail-group_logo.png
// module id = u22F
// module chunks = 9